import { useEffect, useRef } from 'react';
import { useAuthenticatedFetchWithWorkspace } from './Keycloak/useAuthenticatedFetchWithWorkspace';

/**
 * Déclenche `onWorkspaceChange` à chaque fois que le workspace actif change.
 * Permet de mutualiser le pattern prevWorkspaceIdRef dans tous les hooks/pages.
 *
 * @param onWorkspaceChange - callback appelé avec (newWorkspaceId, prevWorkspaceId)
 */
const useWorkspaceChange = (
    onWorkspaceChange: (newId: string, prevId: string) => void
): void => {
    const { workspaceId } = useAuthenticatedFetchWithWorkspace();
    const prevRef = useRef<string | null>(null);
    // Stable ref to avoid stale closure in effect
    const callbackRef = useRef(onWorkspaceChange);
    callbackRef.current = onWorkspaceChange;

    useEffect(() => {
        if (!workspaceId) return;
        if (prevRef.current !== null && prevRef.current !== workspaceId) {
            callbackRef.current(workspaceId, prevRef.current);
        }
        prevRef.current = workspaceId;
    }, [workspaceId]);
};

export default useWorkspaceChange;
